import React from "react";
import { Typography, Paper, Box } from "@mui/material";

import * as styles from "./Styles.js";
import { mainBox } from "../../assets/Variables/SpaceVariables.js";
import { useCookies } from "../../Tools/CookieChecker.js";
import { useIbOptions } from "../../Tools/useIbOptions.js";
import TabsComponent from "../../components/Tabs/TabsComponent.js";
import SummarizedReportTab from "./SummarizedReportTab.js";
import FullReportTab from "./FullReportTab.js";

// IBsPage is now a thin container: it resolves the IB/clients selector
// options ONCE (via Tools/useIbOptions.js, which itself relies on
// Tools/MasterIbChecker.js to know which trees this user is Master IB of),
// and renders two tabs that both reuse that same data:
//   - "Summarized Report": the original My IBs table/filters (unchanged
//     behaviour), now living in IBs/SummarizedReportTab.jsx.
//   - "Full Report": the new tab, hitting POST /ib-report-full, in
//     IBs/FullReportTab.jsx.
function IBsPage() {
  const { name } = useCookies();
  const {
    type,
    canUseIbSelector,
    ibOptions,
    individualEmails,
    ibOptionsLoading,
    ibOptionsError,
    masterTreeIds,
    masterTrees,
  } = useIbOptions();

  return (
    <Box sx={mainBox}>
      <Paper elevation={2} sx={styles.mainPaper}>
        <Box sx={styles.TitleBox}>
          <Typography variant="h5" component="h2" gutterBottom sx={styles.Title}>
            My IBs
          </Typography>
        </Box>

        {ibOptionsError ? (
          <Typography sx={{ mb: 2, color: "error.main", fontWeight: 700 }}>
            {ibOptionsError}
          </Typography>
        ) : null}

        <TabsComponent
          idPrefix="ibs-page"
          tabs={[
            {
              label: "Summarized Report",
              content: (
                <SummarizedReportTab
                  name={name}
                  canUseIbSelector={canUseIbSelector}
                  ibOptions={ibOptions}
                  individualEmails={individualEmails}
                  ibOptionsLoading={ibOptionsLoading}
                />
              ),
            },
            {
              label: "Full Report",
              content: (
                <FullReportTab
                  name={name}
                  type={type}
                  canUseIbSelector={canUseIbSelector}
                  ibOptions={ibOptions}
                  individualEmails={individualEmails}
                  ibOptionsLoading={ibOptionsLoading}
                  masterTreeIds={masterTreeIds}
                  masterTrees={masterTrees}
                />
              ),
            },
          ]}
        />
      </Paper>
    </Box>
  );
}

export default IBsPage;